export default "__VITE_ASSET__CRMvNcns__"